import { ICoordinatesModel } from './coordinates.model';
import { IGateItem } from './gates.model';
import { ICameraItem } from './camera.model';

export interface IParkingLotItem {
  name: string;
  address: string;
  city: string;
  totalSpaces: number;
  occupiedSpaces: number;
  isActive: boolean;
  coordinates: ICoordinatesModel[];
  currency?: string;
  timezone?: string;
  spacesHandicapped: number;
  id?: string;
  gates?: IGateItem[];
  cameras?: ICameraItem[];
}

export interface IParkingLotSession {
  id: string;
  parkingLotId: string;
  vehicleId: string;
  plateNumber: string;
  entryTime: string;
  exitTime?: string;
  entryGateId: string;
  exitGateId: string;
  entryPhotoUrl: string;
  exitPhotoUrl: string;
  tariffId: string;
  rateSnapshot: number;
  durationMinutes: number;
  totalAmount: number;
  prepaidAmount: number;
  prepaidAt: string;
  status: ParkingSessionStatusEnum;
  paymentStatus: PaymentStatusEnum;
  subscriptionId: string;
  createdAt: string;
  updatedAt: string;
}

export interface IParkingLotSessionParams {
  plateNumber?: string;
  status?: ParkingSessionStatusEnum;
  paymentStatus?: PaymentStatusEnum;
  pageIndex?: number;
  pageSize?: number;
}

export enum ParkingSessionStatusEnum {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}

export const IParkingSessionStatusLabel: Record<ParkingSessionStatusEnum, string> = {
  [ParkingSessionStatusEnum.Active]: 'Активный',
  [ParkingSessionStatusEnum.Completed]: 'Завершено',
  [ParkingSessionStatusEnum.Cancelled]: 'Отменено',
};

export enum PaymentStatusEnum {
  Unpaid = 'UNPAID',
  Prepaid = 'PREPAID',
  Paid = 'PAID',
  Debt = 'DEBT',
}

export const IPaymentStatusLabel: Record<PaymentStatusEnum, string> = {
  [PaymentStatusEnum.Unpaid]: 'Не оплачено',
  [PaymentStatusEnum.Prepaid]: 'Предоплата',
  [PaymentStatusEnum.Paid]: 'Оплачено',
  [PaymentStatusEnum.Debt]: 'Задолженность',
};
